<div>
  <h1>Componente Scale</h1>
  <!-- Aquí puedes agregar más contenido HTML -->
  <button (click)="connectToBluetoothDevice()">Conectar a dispositivo Bluetooth</button>
</div> 